import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOrthographic = ({ title, titleId, ...props }) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("path", {
			d: "M13 22.5V11.5L22 7V18.5L13 22.5Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11 11.5L2 7V18.5L11 22.5V11.5Z",
			fill: "#232729"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M12 10L3 5.5L12 1L21 5.5L12 10Z",
			fill: "#232729"
		})
	]
});
export default SvgOrthographic;
